import type { ReactNode } from "react";
import { Header } from "./header";
import { Sidebar, type AdminPage } from "./sidebar";

interface AppLayoutProps {
  page: AdminPage;
  onNavigate: (page: AdminPage) => void;
  email: string;
  onSignOut: () => void;
  children: ReactNode;
}

export function AppLayout({ page, onNavigate, email, onSignOut, children }: AppLayoutProps) {
  return (
    <div className="min-h-dvh">
      <Sidebar page={page} onNavigate={onNavigate} />
      <div className="ml-[200px] flex min-h-dvh flex-col">
        <Header email={email} onSignOut={onSignOut} />
        <main className="flex-1 px-[40px] py-[25px]">{children}</main>
        <footer className="px-[40px] pb-5 text-xs text-foreground/40">
          Pushup Tracker admin — managing celebrity opponents. All pose detection runs on-device.
        </footer>
      </div>
    </div>
  );
}
